// import React, { useState } from "react";
// import { ChevronLeft, X } from "lucide-react";
// import PaymentMethodHandler from "./PaymentHandlerPanel";
//
//
//
// interface CheckoutItem {
//     id: string;
//     name: string;
//     price: number;
//     quantity: number;
//     type?: string;
// }
//
// interface Props {
//     appointment: any;
//     onPaymentSuccess: () => void;
//     onClose:any;
//     onBack:any
// }
//
// const PaymentPanel: React.FC<Props> = ({ appointment, onPaymentSuccess,onClose,onBack }) => {
//     // Local mock states
//     const [showPaymentScreen, setShowPaymentScreen] = useState(true);
//     const [discountType, setDiscountType] = useState<"percentage" | "fixed">(
//         "percentage"
//     );
//     const [discountAmount, setDiscountAmount] = useState(0);
//     const [checkoutItems] = useState<CheckoutItem[]>([
//         { id: "1", name: "Haircut", price: 25, quantity: 1 },
//         { id: "2", name: "Shampoo", price: 10, quantity: 2 },
//     ]);
//
//     const [checkoutAppointment, setCheckoutAppointment] = useState(appointment);
//
//     // ====== Utility Calculations ======
//     const calculateSubtotal = (): number =>
//         checkoutItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
//
//     const calculateDiscount = (): number => {
//         if (discountType === "percentage") {
//             return (calculateSubtotal() * discountAmount) / 100;
//         }
//         return discountAmount;
//     };
//
//     const calculateTax = (): number => {
//         const taxableAmount = calculateSubtotal() - calculateDiscount();
//         return taxableAmount * 0.0875; // 8.75% tax
//     };
//
//     const calculateTotal = (): number =>
//         calculateSubtotal() - calculateDiscount() + calculateTax();
//
//     // ====== Mock Payment Handler ======
//
//
//     if (!showPaymentScreen) return null;
//
//     return (
//         <div className="mt-6 space-y-4">
//             <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-end">
//                 <div className="w-full max-w-lg bg-white shadow-2xl overflow-y-auto transform transition-transform duration-300 ease-in-out">
//                     {/* Header */}
//                     <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-gray-50">
//                         <div className="flex items-center space-x-3">
//                             <button
//                                 onClick={onBack}
//                                 className="p-2 hover:bg-gray-200 rounded-lg transition-colors"
//                             >
//                                 <ChevronLeft className="w-5 h-5 text-gray-600" />
//                             </button>
//                             <h2 className="text-xl font-semibold text-gray-900">Payment</h2>
//                         </div>
//                         <button
//                             onClick={onClose}
//                             className="p-2 hover:bg-gray-200 rounded-lg transition-colors"
//                         >
//                             <X className="w-5 h-5 text-gray-600" />
//                         </button>
//                     </div>
//
//                     <div className="flex-1 overflow-y-auto">
//                         {/* Client Info */}
//                         <div className="p-6 border-b border-gray-200">
//                             <div className="flex items-center space-x-4">
//                                 <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center">
//                   <span className="text-white font-semibold text-lg">
//                     {checkoutAppointment.patientName
//                         .split(" ")
//                         .map((n) => n[0])
//                         .join("")}
//                   </span>
//                                 </div>
//                                 <div>
//                                     <h3 className="text-lg font-semibold text-gray-900">
//                                         {checkoutAppointment.patientName}
//                                     </h3>
//                                     <div className="space-y-1">
//                                         {checkoutAppointment.phone && (
//                                             <p className="text-sm text-gray-600">
//                                                 {checkoutAppointment.phone}
//                                             </p>
//                                         )}
//                                         {checkoutAppointment.email && (
//                                             <p className="text-sm text-gray-600">
//                                                 {checkoutAppointment.email}
//                                             </p>
//                                         )}
//                                         <p className="text-xs text-gray-500">Payment Summary</p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//
//                         {/* Order Summary */}
//                         <div className="p-6 border-b border-gray-200">
//                             <h3 className="text-lg font-semibold text-gray-900 mb-4">
//                                 Order Summary
//                             </h3>
//                             <div className="space-y-2">
//                                 {checkoutItems.map((item, index) => (
//                                     <div
//                                         key={`${item.type}-${item.id}-${index}`}
//                                         className="flex justify-between items-center text-sm"
//                                     >
//                                         <div className="flex-1">
//                                             <span className="text-gray-900">{item.name}</span>
//                                             {item.quantity > 1 && (
//                                                 <span className="text-gray-500 ml-2">
//                           × {item.quantity}
//                         </span>
//                                             )}
//                                         </div>
//                                         <span className="text-gray-900 font-medium">
//                       ${(item.price * item.quantity).toFixed(2)}
//                     </span>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//
//                         {/* Discount Section */}
//                         <div className="p-6 border-b border-gray-200">
//                             <h3 className="text-lg font-semibold text-gray-900 mb-4">
//                                 Discount
//                             </h3>
//                             <div className="space-y-4">
//                                 <div className="flex space-x-2">
//                                     <select
//                                         value={discountType}
//                                         onChange={(e) =>
//                                             setDiscountType(e.target.value as "percentage" | "fixed")
//                                         }
//                                         className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                     >
//                                         <option value="percentage">Percentage</option>
//                                         <option value="fixed">Fixed Amount</option>
//                                     </select>
//                                     <div className="flex-1 relative">
//                                         {discountType === "fixed" && (
//                                             <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
//                         $
//                       </span>
//                                         )}
//                                         <input
//                                             type="number"
//                                             value={discountAmount}
//                                             onChange={(e) =>
//                                                 setDiscountAmount(parseFloat(e.target.value) || 0)
//                                             }
//                                             className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
//                                                 discountType === "fixed" ? "pl-8" : ""
//                                             }`}
//                                             placeholder={discountType === "percentage" ? "0" : "0.00"}
//                                             min="0"
//                                             max={
//                                                 discountType === "percentage" ? 100 : calculateSubtotal()
//                                             }
//                                             step={discountType === "percentage" ? 1 : 0.01}
//                                         />
//                                         {discountType === "percentage" && (
//                                             <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
//                         %
//                       </span>
//                                         )}
//                                     </div>
//                                 </div>
//                                 {discountAmount > 0 && (
//                                     <div className="text-sm text-green-600">
//                                         Discount: -${calculateDiscount().toFixed(2)}
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//
//                         {/* Payment Calculation */}
//                         <div className="p-6">
//                             <div className="space-y-3">
//                                 <div className="flex justify-between items-center text-sm">
//                                     <span className="text-gray-600">Subtotal</span>
//                                     <span className="text-gray-900">
//                     ${calculateSubtotal().toFixed(2)}
//                   </span>
//                                 </div>
//
//                                 {discountAmount > 0 && (
//                                     <div className="flex justify-between items-center text-sm">
//                     <span className="text-gray-600">
//                       Discount (
//                         {discountType === "percentage"
//                             ? `${discountAmount}%`
//                             : `$${discountAmount}`}
//                         )
//                     </span>
//                                         <span className="text-green-600">
//                       -${calculateDiscount().toFixed(2)}
//                     </span>
//                                     </div>
//                                 )}
//
//                                 <div className="flex justify-between items-center text-sm">
//                                     <span className="text-gray-600">Tax (8.75%)</span>
//                                     <span className="text-gray-900">
//                     ${calculateTax().toFixed(2)}
//                   </span>
//                                 </div>
//
//                                 <div className="border-t border-gray-200 pt-3">
//                                     <div className="flex justify-between items-center">
//                     <span className="text-lg font-semibold text-gray-900">
//                       Total
//                     </span>
//                                         <span className="text-lg font-bold text-gray-900">
//                       ${calculateTotal().toFixed(2)}
//                     </span>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//
//                     {/* Payment Buttons */}
//                     <div className="border-t border-gray-200 bg-white">
//                         <div className="p-6">
//                             <div className="space-y-3">
//                                 <div className="text-center mb-4">
//                                     <p className="text-sm text-gray-600 mb-2">
//                                         Select Payment Method
//                                     </p>
//                                     <p className="text-lg font-bold text-gray-900">
//                                         Total: ${calculateTotal().toFixed(2)}
//                                     </p>
//                                 </div>
//
//                                 <div className="space-y-6">
//                                     <div className="text-center">
//                                         <h3 className="text-lg font-medium text-gray-900 mb-2">
//                                             Select Payment Method
//                                         </h3>
//                                         <p className="text-sm text-gray-600">
//                                             Choose how you'd like to complete this payment
//                                         </p>
//                                     </div>
//                                     <PaymentMethodHandler/>
//
//
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };
//
// export default PaymentPanel;

'use client'
import React, { useState, useMemo } from "react";
import { ChevronLeft, X } from "lucide-react";
import PaymentMethodHandler from "./PaymentHandlerPanel";
import {useSelector} from "react-redux";
import {selectAccount} from "../../../redux/accountSlice";
import {getCheckoutBreakdown, paidExtrasLabel} from "../../../utils/checkoutBreakdown";

interface CheckoutItem {
    id: string;
    name: string;
    price: number; // in dollars
    quantity: number;
    type?: string;
}

interface AppointmentProps {
    sale?:any[];
    services?: any[];
    client?: any;
    shop?: { taxPercentage?: number };
    appointment?: { client?: any; services?: any[]; shop?: { taxPercentage?: number } };
}

interface Props {
    appointment: AppointmentProps;
    onPaymentSuccess: () => void;
    onClose: () => void;
    onBack: () => void;
    setAppointmentDrawer:any
    updateCalendarData: () => Promise<void> | void;
}

const PaymentPanel: React.FC<Props> = ({ appointment, onPaymentSuccess, onClose, onBack, setAppointmentDrawer, updateCalendarData }) => {
    const account = useSelector(selectAccount);
    const isServicesTaxable = account?.applyTaxToService
    const isProductsTaxable = account?.applyTaxToProduct

    const [showPaymentScreen, setShowPaymentScreen] = useState(true);
    const [discountType, setDiscountType] = useState<"percentage" | "fixed">("percentage");
    const [discountAmount, setDiscountAmount] = useState(0);

    // ✅ Normalize appointment data
    const normalizedData = useMemo(() => {
        // Prefer nested appointment data if available
        const app:any = appointment.appointment ?? appointment;

        const client = app.client ?? appointment.client ?? {};
        const services = app.services ?? appointment.services ?? [];
        const products = app?.products ?? (appointment as any)?.products ?? [];

        const taxPercentage =  app.shop?.taxPercentage ?? 0;


        // Convert services into checkout items
        const serviceItems: CheckoutItem[] = services.map((service:any) => ({
            id: service.id?.toString() ?? crypto.randomUUID(),
            name: service.title ?? service.businessService?.title ?? "Service",
            price: service.priceCents ? service.priceCents / 100 : parseFloat(service.price?.replace("$", "") || "0"),
            quantity: 1,
            type: 'service',
        }));
        const productItems: CheckoutItem[] = products?.length >0 ?  products?.map((product:any) => ({
            id: product?.id,
            name: product?.title ?? product?.product?.title,
            price: (product?.priceCents || product?.product?.priceCents)
                ? (product?.priceCents || product?.product?.priceCents) / 100
                : parseFloat(product?.price?.replace("$", "") || "0"),
            quantity: product.quantity===0 ? 1 : product.quantity,
            type: 'product',
        })) :[];

        return { client, items:[...serviceItems,...productItems], taxPercentage };
    }, [appointment]);

    const { client, items: checkoutItems, taxPercentage } = normalizedData;

    console.log("checkoutItems", checkoutItems);
    // ====== Utility Calculations ======


    const calculateProductsSubtotal = (): number =>
        checkoutItems.filter((it)=>it.type==='product').reduce((sum, item) => sum + item.price * (item.quantity??1), 0);

  const calculateServicesSubtotal = (): number =>
        checkoutItems.filter((it)=>it.type==='service').reduce((sum, item) => sum + item.price * (item.quantity??1), 0);

    const calculateSubtotal = (): number =>
        checkoutItems.reduce((sum, item) => sum + item.price * (item.quantity??1), 0);


    const calculateDiscount = (): number => {
        if (discountType === "percentage") {
            return (calculateSubtotal() * discountAmount) / 100;
        }
        return discountAmount;
    };

    const calculateTax = (): number => {
        if (isProductsTaxable && !isServicesTaxable){
            const taxableAmount = calculateSubtotal() - calculateServicesSubtotal() - calculateDiscount();
            return taxableAmount * (taxPercentage / 100);
        }else if
        (!isProductsTaxable && isServicesTaxable){

            const taxableAmount = calculateSubtotal() - calculateProductsSubtotal() - calculateDiscount();
            return taxableAmount * (taxPercentage / 100);
        }
       else if (isProductsTaxable && isServicesTaxable){
            const taxableAmount = calculateSubtotal() - calculateDiscount();
            return taxableAmount * (taxPercentage / 100);
        }
       else {
            return 0
        }



    };

    const calculateTotal = (): number =>
        calculateSubtotal() - calculateDiscount() + calculateTax();

    // Live total (with any discount applied here) minus what earlier payments
    // covered, before any card fee - the same figure the payment screen charges.
    const {
        totalCents,
        paidCents,
        paidCardFeeCents,
        paidTipsCents,
        pendingCents,
        cardFeePercentage,
        pendingByCardCents,
        hasPriorPayment,
    } = getCheckoutBreakdown({
        subtotalCents: Math.round(calculateSubtotal() * 100),
        taxCents: Math.round(calculateTax() * 100),
        discountCents: Math.round(calculateDiscount() * 100),
        sale: (appointment as any)?.sale,
        account,
    });
    const formatCents = (cents: number) => `$${(cents / 100).toFixed(2)}`;

    if (!showPaymentScreen) return null;

    // ====== UI ======
    return (
        <div className="mt-6 space-y-4">
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-end">
                <div className="w-full flex scrollbar-hide flex-col justify-between max-w-lg bg-white shadow-2xl transform transition-transform duration-300 ease-in-out">
                    {/* Header */}
                    <div className="flex w-full items-center justify-between p-6 border-b border-gray-200 bg-gray-50">
                        <div className="flex items-center space-x-3">
                            <button
                                onClick={onBack}
                                className="p-2 hover:bg-gray-200 rounded-lg transition-colors"
                            >
                                <ChevronLeft className="w-5 h-5 text-gray-600" />
                            </button>
                            <h2 className="text-xl font-semibold text-gray-900">Payment</h2>
                        </div>
                        <button
                            onClick={onClose}
                            className="p-2 hover:bg-gray-200 rounded-lg transition-colors"
                        >
                            <X className="w-5 h-5 text-gray-600" />
                        </button>
                    </div>

                    <div className="flex-1 h-full scrollbar-hide overflow-y-auto">
                        {/* Client Info */}
                        <div className="p-6 border-b border-gray-200">
                            <div className="flex items-center space-x-4">
                                <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center">
                  <span className="text-white font-semibold text-lg">
                    {client?.name
                        ? client.name
                            .split(" ")
                            .map((n: string) => n[0])
                            .join("")
                        : "?"}
                  </span>
                                </div>
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900">
                                        {client?.name ?? "Unknown Client"}
                                    </h3>
                                    <div className="space-y-1">
                                        {client?.phone && (
                                            <p className="text-sm text-gray-600">{client.phone}</p>
                                        )}
                                        {client?.email && (
                                            <p className="text-sm text-gray-600">{client.email}</p>
                                        )}
                                        <p className="text-xs text-gray-500">Payment Summary</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Order Summary */}
                        <div className="px-6 py-4 border-b border-gray-200">
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">
                                Order Summary
                            </h3>
                            <div className="space-y-2">
                                {checkoutItems.map((item:any) => (
                                    <div
                                        key={`${item.id}-${item.type}`}
                                        className="flex items-center justify-between py-3 border-b border-gray-100"
                                    >
                                        <div className="flex items-center space-x-3">
                                            <div
                                                className={`w-1 h-10 rounded-full ${
                                                    item.type === "service" ? "bg-blue-500" : "bg-green-500"
                                                }`}
                                            />
                                            <div>
                                                <h4 className="font-medium text-gray-900 text-sm">{item.name}</h4>
                                                {item.practitioner && (
                                                    <p className="text-xs text-gray-500">with {item.practitioner}</p>
                                                )}
                                                {item.category && (
                                                    <p className="text-xs text-gray-500">{item.category}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="flex items-center space-x-3">
                <span className="text-sm font-semibold text-gray-900">
                  ${(item?.price * (item?.quantity ?? 1)).toFixed(2)}
                    {/*dollers*/}
                </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Discount Section */}
                        <div className="px-6 py-2 border-b border-gray-200">
                            <h3 className="text-lg font-semibold text-gray-900 mb-1">Discount</h3>
                            <div className="space-y-2">
                                <div className="flex space-x-2">
                                    <select
                                        value={discountType}
                                        onChange={(e) =>
                                            setDiscountType(e.target.value as "percentage" | "fixed")
                                        }
                                        className="px-3 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    >
                                        <option value="percentage">Percentage</option>
                                        <option value="fixed">Fixed Amount</option>
                                    </select>
                                    <div className="flex-1 relative">
                                        {discountType === "fixed" && (
                                            <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                        $
                      </span>
                                        )}
                                        <input
                                            type="number"
                                            value={discountAmount}
                                            onChange={(e) =>
                                                setDiscountAmount(parseFloat(e.target.value) || 0)
                                            }
                                            className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                                                discountType === "fixed" ? "pl-8" : ""
                                            }`}
                                            placeholder={discountType === "percentage" ? "0" : "0.00"}
                                            min="0"
                                            max={
                                                discountType === "percentage"
                                                    ? 100
                                                    : calculateSubtotal()
                                            }
                                            step={discountType === "percentage" ? 1 : 0.01}
                                        />
                                        {discountType === "percentage" && (
                                            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                        %
                      </span>
                                        )}
                                    </div>
                                </div>
                                {discountAmount > 0 && (
                                    <div className="text-sm text-green-600">
                                        Discount: -${calculateDiscount().toFixed(2)}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Payment Calculation */}
                        <div className="px-6 py-4">
                            <div className="space-y-3">
                                <div className="flex justify-between items-center text-sm">
                                    <span className="text-gray-600">Subtotal</span>
                                    <span className="text-gray-900">${calculateSubtotal().toFixed(2)}</span>
                                </div>

                                {discountAmount > 0 && (
                                    <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">
                      Discount (
                        {discountType === "percentage"
                            ? `${discountAmount}%`
                            : `$${discountAmount}`}
                        )
                    </span>
                                        <span className="text-green-600">
                      -${calculateDiscount().toFixed(2)}
                    </span>
                                    </div>
                                )}

                                <div className="flex justify-between items-center text-sm">
                                    <span className="text-gray-600">
                                        Tax ({(isServicesTaxable || isProductsTaxable) ? taxPercentage : 0}%)
                                    </span>
                                    <span className="text-gray-900">${calculateTax().toFixed(2)}</span>
                                </div>
                                {(!isServicesTaxable && isProductsTaxable) && (isServicesTaxable && !isProductsTaxable) && <span
                                    className={'text-xs text-gray-400'}>Tax applied only on {(isServicesTaxable && !isProductsTaxable) ? 'Services' : (isProductsTaxable && !isServicesTaxable) ? 'Products' : ""}</span>
                                }
                                {hasPriorPayment && (
                                    <>
                                        <div className="flex justify-between items-center text-sm">
                                            <span className="text-gray-600">Total</span>
                                            <span className="text-gray-900">{formatCents(totalCents)}</span>
                                        </div>
                                        <div className="flex justify-between items-center text-sm">
                                            <span className="text-gray-600">Paid</span>
                                            <span className="text-gray-900">-{formatCents(paidCents)}</span>
                                        </div>
                                        {paidExtrasLabel(paidCardFeeCents, paidTipsCents) && (
                                            <span className="text-xs text-gray-400">
                                                {paidExtrasLabel(paidCardFeeCents, paidTipsCents)}
                                            </span>
                                        )}
                                    </>
                                )}
                                <div className="border-t border-gray-200 pt-3">
                                    <div className="flex justify-between items-center">
                                        <span className="text-lg font-semibold text-gray-900">
                                            {hasPriorPayment ? "Due now" : "Total"}
                                        </span>
                                        <span className="text-lg font-bold text-gray-900">
                      {formatCents(pendingCents)}
                    </span>
                                    </div>
                                    {cardFeePercentage > 0 && pendingCents > 0 && (
                                        <div className="text-right text-xs text-gray-500 mt-1">
                                            {formatCents(pendingByCardCents)} if paid by card ({cardFeePercentage}% fee)
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Payment Buttons */}
                    <div className="border-t border-gray-200 bg-white">
                        <div className="p-6">
                            <div className="space-y-3">
                                {/*<div className="text-center mb-4">*/}
                                {/*    /!*<p className="text-sm text-gray-600 mb-2">Select Payment Method</p>*!/*/}
                                {/*    <p className="text-lg font-bold text-gray-900">*/}
                                {/*        Total: ${calculateTotal().toFixed(2)}*/}
                                {/*    </p>*/}
                                {/*</div>*/}




                                <div className="space-y-6 w-full p-4">
                                    {/*<div className="text-center">*/}
                                    {/*    <h3 className="text-lg font-medium text-gray-900 mb-2">*/}
                                    {/*        Select Payment Method*/}
                                    {/*    </h3>*/}
                                    {/*    <p className="text-sm text-gray-600">*/}
                                    {/*        Choose how you'd like to complete this payment*/}
                                    {/*    </p>*/}
                                    {/*</div>*/}
                                    <PaymentMethodHandler tax={calculateTax()}  discount={calculateDiscount()} setAppointmentDrawer={setAppointmentDrawer} sale={appointment?.sale} appointmentClient={client} updateCalendarData={updateCalendarData}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentPanel;
